import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-applicationsapprovals',
  templateUrl: './applicationsapprovals.component.html',
  styleUrls: ['./applicationsapprovals.component.css']
})
export class ApplicationsapprovalsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
